import urls from "global/constants/UrlConstants";
import { AddContactFields } from "models/interfaces";
import { getCallParams, getFileCallParams, makeCall } from "utils/service";

export const getContacts = async (
  params: any,
  count: number = 10,
  page: number = 1
) => {
  const url = `${urls.GET_CONTACTS}/limit/${count}/page/${page}`;
  try {
    const callParams = await getCallParams("POST", params);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getContactsCount = async (params: any) => {
  try {
    const callParams = await getCallParams("POST", params);
    const response = await makeCall(urls.GET_CONTACTS_COUNT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addContact = async (contact: AddContactFields) => {
  try {
    const callParams = await getCallParams("POST", contact);
    const response: any = await makeCall(urls.ADD_CONTACTS, callParams, false);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateContact = async (contact: AddContactFields) => {
  try {
    const callParams = await getCallParams("POST", contact);
    const response: any = await makeCall(urls.UPDATE_CONTACTS, callParams, false);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const uploadContactCsv = async (formData: any) => {
  try {
    const callParams = await getFileCallParams("POST", formData);
    const response = await makeCall(urls.UPLOAD_CONTACTS_CSV, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const uploadBulkContactCsv = async (formData: any) => {
  try {
    const callParams = await getFileCallParams("POST", formData);
    const response = await makeCall(urls.UPLOAD_BULK_CONTACT_CSV, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
